"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextfieldValidation = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/semantics/paragraph");
let TextfieldValidation = class TextfieldValidation extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <mm-paragraph color="danger"><slot></slot></mm-paragraph>
    `;
    }
};
TextfieldValidation = __decorate([
    (0, decorators_js_1.customElement)('mm-textfield-validation')
], TextfieldValidation);
exports.TextfieldValidation = TextfieldValidation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dGZpZWxkLXZhbGlkYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0ZXh0ZmllbGQtdmFsaWRhdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBc0M7QUFDdEMscURBQWlEO0FBQ2pELHdEQUFxRDtBQUc5QyxJQUFNLG1CQUFtQixHQUF6QixNQUFNLG1CQUFvQixTQUFRLGdCQUFVO0lBQ2pELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztLQUVWLENBQUE7SUFDSCxDQUFDO0NBQ0YsQ0FBQTtBQU5ZLG1CQUFtQjtJQUQvQixJQUFBLDZCQUFhLEVBQUMseUJBQXlCLENBQUM7R0FDNUIsbUJBQW1CLENBTS9CO0FBTlksa0RBQW1CIn0=